import { useEffect, useState } from 'react';
import { getWaterLogsData } from '../projects/flowers/data/flowers-data-service';
import { closeMobileMenu } from './ui/mobile-menu-provider';
import { FlowerIcon } from '../common/ui/icons';
import { NavLink } from 'react-router-dom';
import { FLOWERS_WATER_LOG_UPDATED } from '../projects/flowers/domain/flowers-provider';

interface IFlowerMenuItem {
    showIcons?: boolean;
}

const FlowerMenuItem = ({ showIcons }: IFlowerMenuItem) => {

    const [waterLogsCount, setWaterLogsCount] = useState(0);

    const getWaterCount = async () => {
        const response = await getWaterLogsData((new Date()).getTime());
        setWaterLogsCount(response?.plants?.length || 0);
    };

    useEffect(() => {
        (async () => {
           await getWaterCount();
        })();
    }, []);


    useEffect(() => {

        const handler = async () => {
            await getWaterCount();
        };

        document.addEventListener(FLOWERS_WATER_LOG_UPDATED, handler);

        return () => {
            document.removeEventListener(FLOWERS_WATER_LOG_UPDATED, handler);
        };
    }, []);

    return (
        <NavLink
            onClick={ closeMobileMenu }
            to="/flowers"
            className="border-b border-slate-700 pb-2 mb-2 flex items-center">
            Flowers
            {
                !!showIcons && !waterLogsCount &&
                <FlowerIcon
                    classes="ml-auto"
                    color={ '#ff4d00' }
                    size={ 20 }
                    strokeWidth={ 1.5 }
                />
            }

            {
                !!waterLogsCount &&
                <span
                    className="text-xs flex items-center justify-center text-white bg-red-600 rounded-full ml-auto"
                    style={{
                        width: '20px',
                        height: '20px',
                        fontSize: '10px',
                    }}>
                        { waterLogsCount }
                    </span>
            }
        </NavLink>
    )
};

export default FlowerMenuItem;